module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "OhioState.ef9eab24.webp";